var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEgypt(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:52661)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.0107C24.8366 32.0107 32 24.8473 32 16.0107C32 7.17419 24.8366 0.0107422 16 0.0107422C7.16344 0.0107422 0 7.17419 0 16.0107C0 24.8473 7.16344 32.0107 16 32.0107Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 0.0107422C9.12049 0.0107422 3.2558 4.35274 0.995117 10.4456H31.0048C28.7441 4.35274 22.8794 0.0107422 15.9999 0.0107422V0.0107422Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 32.0108C22.8794 32.0108 28.7441 27.6688 31.0047 21.576H0.995117C3.2558 27.6688 9.12049 32.0108 15.9999 32.0108Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5651 14.2715H17.3911C17.3911 13.5032 16.7682 12.8802 15.9998 12.8802C15.2314 12.8802 14.6085 13.5032 14.6085 14.2715H10.4346C10.4346 15.04 11.1039 15.6628 11.8723 15.6628H11.8259C11.8259 16.4313 12.4488 17.0542 13.2172 17.0542C13.2172 17.8226 13.8401 18.4455 14.6085 18.4455H17.3911C18.1596 18.4455 18.7824 17.8226 18.7824 17.0542C19.5509 17.0542 20.1737 16.4313 20.1737 15.6628H20.1274C20.8958 15.6628 21.5651 15.04 21.5651 14.2715V14.2715Z",
    fill: "#FF9811"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:52661"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0107422)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEgypt);
export default __webpack_public_path__ + "static/media/egypt.5871a4b5.svg";
export { ForwardRef as ReactComponent };